import React from 'react'
import {Modal, Box} from 'components'
import {useTranslation} from 'react-i18next'
import BuyViewsForm from './BuyViewsForm'

const BuyViewsModal = ({
    hide,
}) => {
    const [t] = useTranslation()
  return (
    <Modal title={t('Køb sponservisninger')} hide={hide}>
        <Box flex-flow="column" p={3}>
            <BuyViewsForm hide={hide}/>   
        </Box>    
  </Modal>   
  )
}

export default BuyViewsModal